import gql from 'graphql-tag';

const UPDATE_NAME_DESCRIPTION_THROTTLE = gql`
  mutation updateThrottleProperties($params: UpdateThrottlePropertiesInput!) {
    updateThrottleProperties(params: $params) {
      throttle {
        uuid
        name
        description
      }
    }
  }
`;

export default UPDATE_NAME_DESCRIPTION_THROTTLE;
